import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND, SOCIAL, ADOPT } from '../../../config/configs';
import './Footer.css';
import { FOOTER_LINKS } from './data/footer.data';
import ROUTES from '../../../config/routes';
import { handleAdoptNavigate } from '../../../utils/adoptNavigate';

export default function Footer () {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">

                {/* Top — Brand + Links */}
                <div className="footer__top">

                    {/* Brand Column */}
                    <div className="footer__brand">
                        <Link to={ROUTES.HOME} className="footer__logo">
                        {BRAND.shortName}
                        <span className="footer__logo-sub">Innovations</span>
                        </Link>
                        <p className="footer__mission">{BRAND.mission}</p>

                        {/* Social Links */}
                        <div className="footer__social">
                            {SOCIAL.linkedin && (
                                <a
                                    href={SOCIAL.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer__social-link"
                                    aria-label="LinkedIn"
                                    >
                                in
                                </a>
                            )}
                            {SOCIAL.twitter && (
                                <a
                                    href={SOCIAL.twitter}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer__social-link"
                                    aria-label="Twitter"
                                >
                                𝕏
                                </a>
                            )}
                            {SOCIAL.github && (
                                <a
                                    href={SOCIAL.github}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer__social-link"
                                    aria-label="GitHub"
                                >
                                GH
                                </a>
                            )}
                            {SOCIAL.instagram && (
                                <a
                                    href={SOCIAL.instagram}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer__social-link"
                                    aria-label="Instagram"
                                >
                                IG
                                </a>
                            )}

                            {SOCIAL.facebook && (
                                <a
                                    href={SOCIAL.facebook}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer__social-link"
                                    aria-label="Facebook"
                                >
                                    f
                                </a>
                            )}
                        </div>
                    </div>

                    {/* Link Columns */}
                    <div className="footer__columns">
                        {FOOTER_LINKS.map((col) => (
                            <div key={col.heading} className="footer__column">
                                <h4 className="footer__column-heading">{col.heading}</h4>
                                <ul className="footer__column-links">
                                {col.links.map((link) => (
                                    <li key={link.label}>
                                    <Link
                                        to={link.path}
                                        className="footer__link"
                                    >
                                        {link.label}
                                    </Link>
                                    </li>
                                ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Divider */}
                <div className="divider" />

                {/* Bottom — Copyright + ADOPT callout */}
                <div className="footer__bottom">
                    <p className="footer__copy">
                        © {currentYear} {BRAND.name}. All rights reserved.
                        Built in Nairobi, Kenya.
                    </p>
                    <a
                        // href={ADOPT.url}
                        href="/"
                        onClick={(e) => {
                            e.preventDefault()
                            handleAdoptNavigate()
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer__adopt"
                    >
                        Powered by{' '}
                        <span className="footer__adopt-name">{ADOPT.name}</span>
                    </a>
                </div>
            </div>
        </footer>
    );
};